/**
 * Selectable colour schemes.
 *
 * `dark` and `light` are the built-ins and carry no data-palette attribute —
 * `light` is the existing `.light-mode` class. Everything else is a named
 * scheme applied via `data-palette` on the document element, whose CSS block
 * outranks both (`:root[data-palette=x]` beats `.light-mode` on specificity).
 *
 * Order matters: the status-bar chip cycles through this list.
 */
const PALETTES = [
  { id: "dark", label: "dark" },
  { id: "light", label: "light" },
  { id: "dracula", label: "dracula" },
  { id: "nord", label: "nord" },
  { id: "tokyo-night", label: "tokyo-night" },
  { id: "catppuccin", label: "catppuccin" },
  { id: "gruvbox", label: "gruvbox" },
  { id: "solarized", label: "solarized" },
  { id: "one-dark", label: "one-dark" },
]

export const PALETTE_IDS = PALETTES.map(p => p.id)

/** Named schemes get a data-palette attribute; the two built-ins do not. */
export const isNamedPalette = id => id !== "dark" && id !== "light"

export default PALETTES
